// extracted by mini-css-extract-plugin
export var root = "related-pages-module--root--M57Kf";
export var listItem = "related-pages-module--listItem--Jm4Dg";
export var headline = "related-pages-module--headline--NKNDD";
export var grid = "related-pages-module--grid--tAnM8";
export var related_pages = "related-pages-module--related_pages--EkJqJ";